import React from "react";

let gradientSeq = 0

// Minh họa full-bleed: nhà thờ + khuôn viên (cây, sân, đồi), dùng làm placeholder
// khi bài viết/kênh chưa có ảnh. Vẽ theo lớp (sky/hills/ground/trees/church) với
// opacity giảm dần từ nền vào tiền cảnh để tạo chiều sâu, phủ kín toàn khung qua
// viewBox + preserveAspectRatio="xMidYMid slice" (co giãn theo mọi kích thước).
export const ChurchScenePlaceholder = ({height = 150, width = '100%', borderRadius = 8, className = ''}) => {
    const gradientId = React.useMemo(() => `churchSceneSky-${gradientSeq++}`, [])

    return (
        <div
            className={className}
            style={{width, height, borderRadius, overflow: 'hidden', flexShrink: 0}}>
            <svg width="100%" height="100%" viewBox="0 0 300 200" preserveAspectRatio="xMidYMid slice">
                <defs>
                    <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#fdf3e3"/>
                        <stop offset="100%" stopColor="#f0e6d6"/>
                    </linearGradient>
                </defs>

                {/* Sky */}
                <rect x="0" y="0" width="300" height="200" fill={`url(#${gradientId})`}/>

                {/* Sun glow */}
                <circle cx="222" cy="52" r="40" fill="#f5deb3" opacity="0.45"/>

                {/* Distant hills */}
                <path
                    d="M0 138 Q60 108 130 133 Q200 156 300 122 L300 200 L0 200 Z"
                    fill="#cdbfa5" opacity="0.35"/>

                {/* Ground */}
                <path
                    d="M0 155 Q90 140 170 158 Q240 172 300 150 L300 200 L0 200 Z"
                    fill="#b7a687" opacity="0.5"/>

                {/* Cây bên trái */}
                <g opacity="0.55" fill="#6b7860">
                    <ellipse cx="52" cy="118" rx="10" ry="34"/>
                    <rect x="49" y="150" width="6" height="14"/>
                </g>
                <g opacity="0.4" fill="#6b7860">
                    <ellipse cx="72" cy="128" rx="7" ry="24"/>
                    <rect x="69.5" y="150" width="5" height="12"/>
                </g>

                {/* Cây bên phải */}
                <g opacity="0.55" fill="#6b7860">
                    <ellipse cx="248" cy="118" rx="10" ry="34"/>
                    <rect x="245" y="150" width="6" height="14"/>
                </g>
                <g opacity="0.4" fill="#6b7860">
                    <ellipse cx="228" cy="128" rx="7" ry="24"/>
                    <rect x="225.5" y="150" width="5" height="12"/>
                </g>

                {/* Lối đi sân nhà thờ */}
                <path d="M140 200 L149 168 L161 200 Z" fill="#cdbfa5" opacity="0.6"/>

                {/* Nhà thờ */}
                <g fill="#8a6b52">
                    <rect x="110" y="118" width="80" height="46"/>
                    <path d="M100 118 L150 90 L200 118 Z"/>
                    <rect x="142" y="70" width="16" height="24"/>
                    <path d="M134 70 L166 70 L150 50 Z"/>
                </g>
                <path d="M150 50V36M143 42H157" stroke="#8a6b52" strokeWidth="3" strokeLinecap="round"/>
                <path d="M138 164V140Q138 130 150 130Q162 130 162 140V164Z" fill="#5c4632"/>
                <circle cx="122" cy="132" r="5" fill="#5c4632"/>
                <circle cx="178" cy="132" r="5" fill="#5c4632"/>
            </svg>
        </div>
    );
}
